import 'swiper/css/swiper.min.css';
import Swiper from 'swiper/js/swiper.min.js';

let leaderTabBarSwiper = null,
    leaderTabDetailSwiper = null;

function initLeaderTabBarSwiper(id) {
    leaderTabBarSwiper = new Swiper('.leader-tab-bar-swiper', {
        initialSlide: id - 1,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        resistanceRatio: 0,
        loop: $(window).outerWidth() < 768,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
            slideChange() {
                if ($(window).outerWidth() < 768 && leaderTabDetailSwiper) {
                    leaderTabDetailSwiper.slideTo(this.realIndex);
                }
            },
        },
    });
}

function initLeaderTabDetailSwiper(id) {
    let prevRealIndex = 0;
    leaderTabDetailSwiper = new Swiper('.leader-tab-detail-swiper', {
        initialSlide: id - 1,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        resistanceRatio: 0,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange(e) {
                if ($(window).outerWidth() < 768) {
                    return;
                }

                if (
                    this.realIndex > prevRealIndex &&
                    this.realIndex - leaderTabBarSwiper.activeIndex > 4
                ) {
                    leaderTabBarSwiper.slideTo(Math.max(0, this.realIndex - 4));
                }

                if (
                    this.realIndex < prevRealIndex &&
                    this.realIndex - leaderTabBarSwiper.activeIndex < 1
                ) {
                    leaderTabBarSwiper.slideTo(this.realIndex - 1);
                }

                $(leaderTabBarSwiper.slides[this.realIndex])
                    .addClass('active')
                    .siblings()
                    .removeClass('active');

                prevRealIndex = this.realIndex;
            },
        },
    });
}

function initLeaderIntroduction(id = 1) {
    initLeaderTabBarSwiper(id);
    initLeaderTabDetailSwiper(id);

    $(window).outerWidth() >= 768 &&
        $('.leader-introduction .desc').each(function (index, elem) {
            if (
                $(elem).parent().height() /
                    $('.leader-tab-detail-swiper').height() >
                0.6999
            ) {
                $(elem).parent().css({
                    height: '70%',
                }); // 尽管max-height可以限制最大高度，但在IE中，max-height制造的限制无法产生滚动条
            }

            $(elem).on('mouseenter', function () {
                let coverBar = $(elem)
                    .siblings('.scroll-bar')
                    .children('.cover-bar');

                let coverBarHeight = 100;
                coverBarHeight =
                    ($(elem).height() / $(elem).prop('scrollHeight')) * 100;

                if (coverBarHeight < 100) {
                    coverBar.height(coverBarHeight + '%');
                    coverBar.fadeIn(300);
                }
            });

            $(elem).on('mouseleave', function () {
                $(elem)
                    .siblings('.scroll-bar')
                    .children('.cover-bar')
                    .fadeOut(300);
            });

            $(elem).scroll(function () {
                $(this)
                    .siblings('.scroll-bar')
                    .children('.cover-bar')
                    .css({
                        top: `${
                            ($(this).scrollTop() /
                                $(this).prop('scrollHeight')) *
                            100
                        }%`,
                    });
            });
        });

    $('.leader-introduction').on('click', '.tab-entry', function (e) {
        if ($(window).outerWidth() < 768) {
        } else {
            $(this).addClass('active').siblings().removeClass('active');
            leaderTabDetailSwiper.slideTo(
                $(this).data('index') - 1 + leaderTabBarSwiper.slides.length
            );
        }
    });

    $(document).scroll(function () {
        if ($(window).outerWidth() < 768) {
            if ($(this).scrollTop() >= $('.leader-introduction').offset().top) {
                $('.leader-tab-bar-swiper').addClass('fixed-top');
            } else {
                $('.leader-tab-bar-swiper').removeClass('fixed-top');
            }
        }
    });
}

window.leaderTabBarSwiper = leaderTabBarSwiper;
window.leaderTabDetailSwiper = leaderTabDetailSwiper;

export default initLeaderIntroduction;
